// FILE: src/services/readingProgressService.js
//
// Self-attested OFFICIAL READING checkoffs for the Study Plan Command
// Center. Reuses learner_prep_tasks (row present = read) with task_key
// 'read:<refId>' — no new table, same RLS, same delete-to-uncheck
// semantics as the logistics checklist.

import { supabase } from './supabaseClient';
import { readingListFor, readingTaskKey } from './studyPlanReading';
import { setLogisticsDone } from './examLogisticsService';

/**
 * Load the reading list for a cert merged with checkoff state.
 * @returns {Promise<{ items: object[], done: number, total: number, pct: number }>}
 */
export async function loadReadingProgress(examId) {
  const defs = readingListFor(examId);
  let doneKeys = new Set();
  try {
    const { data, error } = await supabase
      .from('learner_prep_tasks')
      .select('task_key')
      .eq('exam_id', examId)
      .like('task_key', 'read:%');
    if (!error && Array.isArray(data)) doneKeys = new Set(data.map((r) => r.task_key));
  } catch (_) { /* signed-out — render unchecked */ }

  const items = defs.map((d) => ({ ...d, taskKey: readingTaskKey(d.refId), checked: doneKeys.has(readingTaskKey(d.refId)) }));
  const done = items.filter((i) => i.checked).length;
  const total = items.length;
  return { items, done, total, pct: total ? Math.round((100 * done) / total) : 0 };
}

/** Check / un-check one reading reference. */
export function setReadingDone(refId, examId, done) {
  return setLogisticsDone(readingTaskKey(refId), examId, done);
}
